export let distrikt = {};
export const setDistrikt = (d) => distrikt = d;

export function isOptionalDistrikt(id) {
  return (id.indexOf('bruker_id2') > -1) || (id.indexOf('bruker_id3') > -1);
}

export function isValidDistrikt(d) {
  const l = distrikt.length;
  for (let i = 0; i < l; i++) {
    if (distrikt[i].value === d) { return true; }
  }
  return false;
}

function enableDisableOptionsFromValues(ev, dv, s) {
  if (debug < 5) { console.log('enable', ev, 'disable', dv); }
  const di = getIndexFromValue(dv, s);
  const ei = getIndexFromValue(ev, s);
  if (ei > 0) { s.options[ei].disabled = false; }
  if (di > 0) { s.options[di].disabled = true; }
}

function updateDisabledOptions(e, previous_v, v) {
  if (locallyAr5) return;
  // console.log('updateDisabledOptions');
  const id = e.id;
  const infoBox = e.closest('.info-box');
  const sibling1 = infoBox.getElementsByClassName('reinbeitebruker_id')[0];
  const sibling2 = infoBox.getElementsByClassName('reinbeitebruker_id2')[0];
  const sibling3 = infoBox.getElementsByClassName('reinbeitebruker_id3')[0];
  if ( id === 'reinbeitebruker_id' && sibling2 && sibling3 ) {
    enableDisableOptionsFromValues(previous_v, v, sibling2);
    enableDisableOptionsFromValues(previous_v, v, sibling3);
  }
  if (id.indexOf('reinbeitebruker_id2') > -1 && sibling1 && sibling3) {
    enableDisableOptionsFromValues(previous_v, v, sibling1);
    enableDisableOptionsFromValues(previous_v, v, sibling3);
  }
  if (id.indexOf('reinbeitebruker_id2') > -1 && sibling1 && sibling2) {
    enableDisableOptionsFromValues(previous_v, v, sibling1);
    enableDisableOptionsFromValues(previous_v, v, sibling2);
  }
}
